export default "__VITE_ASSET__4addd1b9__"